module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "left-footer"
  }, [_c('a', {
    staticClass: "resume",
    attrs: {
      "href": _vm.resume,
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "resume-link"
  }, [_vm._v("Resume PDF")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "right-footer"
  }, [_c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.github,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github"
  })]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.linkedin,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-linkedin"
  })])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright"
  }, [_c('p', [_vm._v(" ©Animesh 2017")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d880783","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sections/Footer.vue
// module id = 55
// module chunks = 0